import { z } from "zod";
import { RuleGroupType } from "@common/types/transactionRule";

export const RULES_TAB_SEARCH_PARAM = "tab";
export const RULES_RULE_ID_SEARCH_PARAM = "ruleId";
export const RULES_FILTERS_SEARCH_PARAM = "filters";

export const rulesUrlFiltersSchema = z.object({
    categoryId: z.string().optional(),
    ledgerAccountIds: z.array(z.string()).optional(),
    entityIds: z.array(z.number()).optional(),
});

export type RulesUrlFilters = z.infer<typeof rulesUrlFiltersSchema>;

interface CreateRulesUrlParams {
    tab?: RuleGroupType;
    ruleId?: string;
    filters?: RulesUrlFilters;
}

export function createRulesUrl({
    tab,
    ruleId,
    filters,
}: CreateRulesUrlParams = {}): string {
    const serializedFilters = JSON.stringify(
        rulesUrlFiltersSchema.parse(filters ?? {}),
    );
    const params: Array<[string, string | undefined]> = [
        [RULES_TAB_SEARCH_PARAM, tab],
        [RULES_RULE_ID_SEARCH_PARAM, ruleId],
        [
            RULES_FILTERS_SEARCH_PARAM,
            serializedFilters === "{}" ? undefined : serializedFilters,
        ],
    ];
    const query = params
        .flatMap(([key, value]) =>
            value ? [`${key}=${encodeURIComponent(value)}`] : [],
        )
        .join("&");
    return query ? `/rules?${query}` : "/rules";
}
